import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'

import {Dialog,DialogContent,DialogActions, TextField, Grid, IconButton, Switch, Select, FormControl, InputLabel, MenuItem} from '@material-ui/core'

import { MdClose as CloseIcon, MdSave as SaveIcon, MdDelete as DeleteIcon } from 'react-icons/md'
import callAccountsApi from '../data-provider'

const styles = theme => ({
  errorMessage: {
    color:"red"
  },
})

class CarForm extends Component {

  constructor(props, context) {
    super(props, context)
    this.state = {car:null,errorMessage:null}
  }

  componentDidUpdate(prevProps) {
    if (this.props.car !== prevProps.car)
    {
      let car = this.props.car

      if (car === null)
      {
        car = {active:1}
      }

      this.setState({car})
    }
  }

  handleChange = event => {
    let car = this.state.car
    car[event.target.name] = event.target.value
    this.setState({car})
  }

  save = async () => {
    if (!this.state.car.user_id)
    {
      this.setState({errorMessage:"Please choose an owner"})
      return
    }

    await callAccountsApi("manage","saveCar",{car:this.state.car})
    this.props.close(true)
  }

  delete = async () => {
    let ok = window.confirm("Remove this car? It will be marked inactive, not deleted.")

    if (!ok)
    {
      return
    }

    await callAccountsApi("manage","deleteCar",{car_id:this.state.car.car_id})
    this.props.close(true)
  }

  render() {
    const { classes, open ,close} = this.props
    const car = this.state.car

    return car ? (
      <Dialog fullWidth={true} maxWidth="lg" open={open} onClose={close}>
        <DialogContent>
          <Grid container spacing={3} style={{marginBottom:"30px"}}>
            <Grid item>
              <TextField
                id="car_make"
                name="car_make"
                label="Car Make"
                value={car.car_make ? car.car_make : ""}
                variant="outlined"
                onChange={this.handleChange}
                style={{width: 300}}
              />
            </Grid>

            <Grid item>
              <TextField
                id="registration"
                name="registration"
                label="Registration"
                value={car.registration ? car.registration : ""}
                variant="outlined"
                onChange={this.handleChange}
                style={{width: 200}}
              />
            </Grid>
          </Grid>

          <Grid container spacing={3} style={{marginBottom:"30px"}}>
            <Grid item>
              <FormControl style={{minWidth: 300}}>
                <InputLabel id="user_id-label">Owner</InputLabel>
                <Select value={car.user_id ? car.user_id : ""} onChange={this.handleChange} name="user_id" labelId="user_id-label">
                  {this.props.users.map(u => <MenuItem key={u.user_id} value={u.user_id}>{u.name}</MenuItem>)}
                </Select>
              </FormControl>
            </Grid>

            <Grid item>
              <Grid component="label" container item alignItems="center" spacing={1}>
                <Grid item>Inactive</Grid>
                <Grid item>
                  <Switch
                    checked={car.active === 1}
                    onChange={(event,value) => this.handleChange({target:{name:"active",value:value ? 1 : 0}})}
                    color="primary"
                  />
                </Grid>
                <Grid item>Active</Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <div style={{flex: '1 0 0'}} />
          <span className={classes.errorMessage}>{this.state.errorMessage}</span>
          <div style={{flex: '1 0 0'}} />

          {car.car_id &&
            <IconButton onClick={this.delete} color="secondary">
              <DeleteIcon/>
            </IconButton>
          }

          <IconButton onClick={close} color="primary">
            <CloseIcon/>
          </IconButton>

          <IconButton onClick={this.save} color="primary">
            <SaveIcon/>
          </IconButton>
        </DialogActions>
      
      </Dialog>
    ) : ''
  }
}

export default withStyles(styles)(CarForm)
